<template>
	<md-app>
		<md-app-toolbar class="md-transparent" md-elevation="1">
			<toolbar />
		</md-app-toolbar>
		<md-app-drawer md-permanent="clipped">
			<md-list>
				<md-list-item to="skuGroups">Sku Groups</md-list-item>
				<md-list-item to="skuTree">Sku Tree</md-list-item>
			</md-list>
		</md-app-drawer>
		<md-app-content>
			<router-view />
		</md-app-content>
	</md-app>
</template>

<script>
import Toolbar from '@/components/Common/Toolbar.vue'
export default {
	name: 'SKUManagementHome',
	components: { toolbar: Toolbar },
}
</script>

<style scoped>
.hidden {
	visibility: hidden;
}
</style>